import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoginCredentials } from "@/api/tokens";
import { SpinButton } from "@/components/form/SpinButton";
import { useLoginQuery } from "@/queries/auth.queries";
import { useState } from "react";

export function ScanBadgeManual() {
  const [credentials, setCredentials] = useState<LoginCredentials>({ grantType: "Password", barcode: "" });
  const login = useLoginQuery(true);

  function handleLogin(e: React.FormEvent) {
    e.preventDefault();
    login.mutate(credentials);
  }

  return (
    <div id="body" className="about-area space__bottom--r120">
      <div className="container">
        <div className="row align-items-center row-25">
          <div className="col-md-6 order-2 order-md-1">
            <div className="about-content">
              <div className="section-title space__bottom--25">
                <h2 className="section-title__title">Scan your badge</h2>
              </div>
              <form onSubmit={handleLogin}>
                <div className="about-content__text mb-3">
                  <div className="form-floating has-feedback has-feedback-left mb-2">
                    <input
                      className="form-control"
                      name="barcode"
                      value={credentials.barcode}
                      onChange={(e) => setCredentials((prev) => ({ ...prev, barcode: e.target.value }))}
                      autoFocus
                      required
                    />
                    <label htmlFor="barcode">Barcode/QR Code</label>
                    <FontAwesomeIcon className="form-control-feedback" icon={faUser} />
                  </div>
                </div>
                {login.isError && <p className="alert alert-danger">User not found, please re-scan.</p>}
                <SpinButton id="login_btn" type="submit" className="btn btn-default" loading={login.isLoading}>
                  Log in
                </SpinButton>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
